import { isProduction } from "../services/constants";
import AuraLogsServices from "../services/AuraLogsServices";
import {
  decideErrorCode,
  getDeviceInfo,
  isErrorNonReproducible
} from "../services/utils";
import CookieService from "../services/CookieService";
import * as Sentry from "@sentry/nextjs";

export function reportException(reportObj) {
  let deviceInfo = {};
  let deviceId = "";
  const firstArg = arguments[0];
  const { error = {}, errorInfo = "" } = reportObj || {};
  let { errorCode = "" } = reportObj || {};
  if (!errorCode) {
    errorCode = decideErrorCode(error);
  }
  const { config = {}, response = {}, message = "" } = error;
  const { status = "" } = response;
  const context = {
    errorObj: {
      code: `REC-WEB-${errorCode}`,
      label: "REC_WEB_ERROR"
    },
    log: JSON.stringify(error),
    fileName: "REC-WEB",
    functionName: "REC-WEB"
  };

  if (typeof firstArg === "object") {
    if (typeof window !== "undefined") {
      deviceInfo = getDeviceInfo();
      deviceId = CookieService.getCookie("recDeviceId");
    }
    const tags = {};
    let { url } = config;
    if (typeof window !== "undefined" && !url) {
      url = window.location.href;
    }
    tags.userAgent = deviceInfo.userAgent;
    tags.deviceHeight = deviceInfo.deviceHeight;
    tags.deviceWidth = deviceInfo.deviceWidth;
    tags.deviceId = deviceId;
    tags.url = url;
    tags.message = message;
    tags.errorInfo = errorInfo;
    context.log = JSON.stringify(tags);
  } else if (typeof firstArg === "string") {
    context.log = firstArg;
  }

  if (
    (function () {
      if (!isProduction) {
        console.log(firstArg);
        return false;
      }
      if (status) return false;
      if (isErrorNonReproducible(message)) return false;
      return true;
    })()
  )
    AuraLogsServices(context);

    Sentry.captureException(error, {
      tags: {
        errorCode: `REC-WEB-${errorCode}`,
        source: "ErrorBoundary",
      },
      extra: {
        errorInfo,
        auraContext: context,
      },
    });
}

export const reportMessage = msg => {
  console.log("error", msg);
};
